import type { ItandiHeader } from "@itandi/brand-ui/ItandiHeader";
import type { ComponentProps } from "react";
import { createContext } from "react";
import type { CompanySetting } from "./CompanySetting";
import type { CompanyStoreSetting } from "./CompanyStoreSetting";
import type { Staff } from "./Staff";

export type ItandiAccount = {
	company: CompanySetting | null;
	isAdmin: boolean;
	productParams: ComponentProps<typeof ItandiHeader>["productMenus"];
	staff: Staff | null;
	store: CompanyStoreSetting | null;
};

const defaultItandiAccount = {
	company: null,
	isAdmin: false,
	productParams: [],
	staff: null,
	store: null
};

export const ItandiAccountContext =
	createContext<ItandiAccount>(defaultItandiAccount);
